import { Link, useLocation } from '@tanstack/react-router'
import { FC } from 'react'

import { Button, Icon } from '@hap/components'

export class CrushedParamError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'CrushedParamsError'
  }
}

export const CrushedParamActions: FC = () => {
  const location = useLocation()
  return (
    <Button asChild>
      <Link to={location.pathname}>
        <Icon name="arrow-clockwise" />
        Clear Filters & Refresh
      </Link>
    </Button>
  )
}
